import React, {Component} from 'react';
import {connect} from 'react-redux';

import DiagnosesHeadingOutput from '../../components/DiagnosesHeadingOutput/DiagnosesHeadingOutput';
import Loader from './../../components/Loader/Loader'
import * as helpActionTypes from './../../store/actions/helpAction';

/**
 * Diagnoses Heading container
 */
class DiagnosesHeading extends Component {
  render() {
    const {data, error, pending, ready, openModalWithContent} = this.props;

    // If data is pending
    if(pending || !ready) return (
      <Loader/>
    );
    // Return switcher
    return (
      <div className='nppe2-fc-diagnoses-heading__wrapper'>
        {error && <span className='nppe2-fc-diagnoses-heading__error'>{error}</span>}
        {!error &&
        <DiagnosesHeadingOutput
          data={data}
          openModalWithContent={openModalWithContent}
        />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.diagnosesReducer.error,
    data: state.diagnosesReducer.data,
    pending: state.diagnosesReducer.pending,
    ready: state.diagnosesReducer.ready,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    openModalWithContent: (key) => dispatch({
      type: helpActionTypes.OPEN_MODAL_WITH_CONTENT,
      key: key,
      open: true,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DiagnosesHeading);
